import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

import { Production } from '../../models/production.model';
import { ProductionReportService } from '../../services/production-report.service';
import * as ProductionActions from '../actions/production.actions';

@Injectable()
export class ProductionEffects {
  private readonly actions$ = inject(Actions);
  private readonly productionReportService = inject(ProductionReportService);

  protected loadProductionList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductionActions.loadProductionListRequest),
      mergeMap(() =>
        this.productionReportService
          .getList()
          .pipe(
            map((productionList: Production[]) =>
              ProductionActions.loadProductionListSuccess({ productionList }),
            ),
          ),
      ),
    ),
  );
}
